<template>
  <div>
    <p>
      Aquesta tarja serveix per a <strong>destacar una frase d'un càrrec públic</strong>.
    </p>
    <p>
      Recomanem usar una <strong>foto del càrrec públic</strong>, idealment <strong>en una entrevista o fent declaracions</strong>.
    </p>
    <p>
      Al camp autor o mitjà, recomanem posar primer el nom del càrrec citat, opcionalment, el seu càrrec, i el mitjà on ha fet les declaracions. Per favor,
      assegureu-vos que heu escrit la frase correctament i sense faltes d'ortografia, i que no heu modificat la cita.
    </p>
    <p>
      És pot afegir, si és adient el nom del col·lectiu al costat del logo, utilizant el camp "afegir text al logo".
    </p>
    <p>
      Aquest model de tarja accepta els següents formats:
    </p>
    <ul>
      <li><strong>1:1</strong>: model genèric per a compartir en la majoria de xarxes socials (Facebook, Instagram, canals de Telegram i Whatsapp, etc.). Aquest model compta amb dues disposicions. És recomana alternar entre les dues si publiqueu amb freqüència.</li>
      <li><strong>9:16</strong>: model per a stories (Instagram, Facebook, Whatsapp). Aquest model no inclou el logo de Comporomís perquè ja és mostra a la part superior esquerra quan es comparteix en l'aplicació. Per favor, no l'afegiu.</li>
      <li><strong>16:9</strong>: model per a Twitter.</li>
    </ul>

    <div class="help-examples">
      <img src="./examples/11.png" alt="Exemple 1:1" />
      <img src="./examples/916.png" alt="Exemple 9:16" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'generic-help'
}
</script>
